import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { Collapse } from 'flowbite';
import type { CollapseOptions, CollapseInterface } from 'flowbite';
import type { InstanceOptions } from 'flowbite';
@Component({
  selector: 'app-cms-header',
  templateUrl: './cms-header.component.html',
  styleUrls: ['./cms-header.component.scss']
})
export class CmsHeaderComponent implements AfterViewInit  {

  @ViewChild('targetEl') targetEl!: ElementRef;
  @ViewChild('triggerEl') triggerEl!: ElementRef;

  collapseInstance: CollapseInterface | undefined;

  ngAfterViewInit() {
    const options: CollapseOptions = {
      onCollapse: () => {
        console.log('element has been collapsed');
      },
      onExpand: () => {
        console.log('element has been expanded');
      },
      onToggle: () => {
        console.log('element has been toggled');
      },
    };

    const instanceOptions: InstanceOptions = {
      id: 'targetEl',
      override: true
    };

    if (this.targetEl && this.triggerEl) {
      const $targetEl: HTMLElement | null = this.targetEl.nativeElement;
      const $triggerEl: HTMLElement | null = this.triggerEl.nativeElement;

      if ($targetEl && $triggerEl) {
        this.collapseInstance = new Collapse(
          $targetEl,
          $triggerEl,
          options,
          instanceOptions
        );
      }
    }
  }

  // Método para expandir o elemento
  expandElement() {
    if (this.collapseInstance) {
      this.collapseInstance.expand();
    }
  }
}
